export default __webpack_public_path__ + "static/media/exceptional.928305bb.png";